export const AGENT_ACCESSIBLE_VIEWS = new Set([
    'dashboard',
    'ai-assistant',
    'training',
    'new-training',
    'training-test',
    'send-offer',
    'bundle-builder-beta',
    'tv-packages',
    'tv-packages-v2',
    'promo-combo-price',
    'rogers-pricing',
    'my-history',
    'escalations'
]);

export const PROCESSING_ACCESSIBLE_VIEWS = new Set([
    'bundle-builder-beta',
    'promo-combo-price',
    'rogers-pricing'
]);

export const PROCESSING_ALLOWED_ROUTES = new Set([
    '/offers/bundle-builder-beta',
    '/offers/promo-combo-price',
    '/offers/rogers-pricing'
]);

export function isProcessingRouteAllowed(pathname) {
    return PROCESSING_ALLOWED_ROUTES.has(String(pathname || ''));
}
